import React from "react";
import {connect} from "react-redux";
import DateRange from './DateRange';
import DataTable from '../../components/Table';
import {
    proposalCount2,
    getSelectedProposalData2,
    changeType,
    getPaymentMethodData,
    resetPaymentMethod
} from '../../store/actions/dashboardActions';
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
import {formateDate, pastDate} from "../../utils/utils";

class ProposalDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDateRange: false,
            showPaymentPopUp: false,
            selectedPn: ""
        };
    }

    componentDidMount() {
        this.props.proposalCount2((data) => {

        });
        let ed = new Date();
        let sd = formateDate(ed,'-')+" 00:00:00";
        ed = formateDate(ed,'-')+" 23:59:59";
        this.props.getSelectedProposalData2('fromDate=' + sd + '&toDate=' + ed,'day');
    }

    componentWillReceiveProps(nextProps) {

    }

    getProposals = (type) => {
        if (type !== this.props.dashboardData.selectedType) {
            let ed = new Date();
            let sd;
            if(type === 'day'){
                sd = formateDate(ed,'-')+" 00:00:00";
            }
            else if(type === 'week'){
                sd = pastDate(ed,7);
                sd = formateDate(sd,'-')+" 00:00:00";
            }
            else if(type === 'month'){
                sd = pastDate(ed,30);
                sd = formateDate(sd,'-')+" 00:00:00";
            }
            ed = formateDate(ed,'-')+" 23:59:59";
            this.props.getSelectedProposalData2('fromDate=' + sd + '&toDate=' + ed,type)
            this.setState({
                showDateRange: false
            })
        }
    }

    openDateRange = () => {
        this.setState({showDateRange: true});
        this.props.changeType('dateRange');
    }
    applyDateRange = (startDtae, endDate) => {
        startDtae = startDtae+" 00:00:00";
        endDate = endDate + " 23:59:59";
        this.props.getSelectedProposalData2('fromDate=' + startDtae + '&toDate=' + endDate)
    }

    render() {
        const { selectedType, proposalCount, selectedProposals } = this.props.dashboardData;
        const { showDateRange, showPaymentPopUp, selectedPn } = this.state;

        return (
            <div className="proposal-dashboard">
                <div className="proposal-dashboard__header">
                    <h2 className="proposal-dashboard__title">Proposals Overview</h2>
                    <p className="proposal-dashboard__subtitle">
                        View and export proposal data by time period
                    </p>
                </div>

                <div className="view-options proposal-dashboard__filters">
                    <div
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                            this.getProposals('day')
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                this.getProposals('day');
                            }
                        }}
                        className={`view-count proposal-dashboard__filter-card ${selectedType === 'day' ? 'selected' : ''}`}>
                        <span className="proposal-dashboard__filter-label">Today</span>
                        <span className="proposal-count proposal-dashboard__filter-count">{proposalCount.today}</span>
                    </div>
                    <div
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                            this.getProposals('week')
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                this.getProposals('week');
                            }
                        }}
                        className={`view-count proposal-dashboard__filter-card ${selectedType === 'week' ? 'selected' : ''}`}>
                        <span className="proposal-dashboard__filter-label">This Week</span>
                        <span className="proposal-count proposal-dashboard__filter-count">{proposalCount.week}</span>
                    </div>
                    <div
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                            this.getProposals('month')
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                this.getProposals('month');
                            }
                        }}
                        className={`view-count proposal-dashboard__filter-card ${selectedType === 'month' ? 'selected' : ''}`}>
                        <span className="proposal-dashboard__filter-label">This Month</span>
                        <span className="proposal-count proposal-dashboard__filter-count">{proposalCount.month}</span>
                    </div>
                    <div
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                            this.openDateRange()
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                this.openDateRange();
                            }
                        }}
                        className={`view-count proposal-dashboard__filter-card proposal-dashboard__filter-card--date ${showDateRange ? 'selected' : ''}`}>
                        <span className="proposal-dashboard__filter-label">Custom Range</span>
                        <span className="proposal-dashboard__filter-hint">Pick dates</span>
                    </div>
                </div>
                {
                    showDateRange &&
                    <div className="proposal-dashboard__date-range-panel">
                        <div className="date-range proposal-dashboard__date-range">
                            <DateRange
                                applyDateRange={this.applyDateRange}
                                // startTimestamp={startTimestamp}
                                // endTimestamp={endTimestamp}
                                // onCancel={() => {setShowByDateRange(false); setSelectedFilter("all") }}
                            />
                        </div>
                    </div>
                }
                {selectedProposals ? <div className="proposal-dashboard__table-section"><DataTable
                    cellHeaders={['Policy ID', 'Lead ID', 'Proposal Number', 'Policy Number',
                        'Payment Status',
                        'Payment Transaction Date',
                        'Refund',
                        'Partner Name',
                        'Total Premium - without GST',
                        'Sum Assured',
                        'Frequency',
                        'Quote No',
                        'Email',
                        'Phone Number',
                        'Policy Created',
                        'Policy Status',
                        'Journey Status',
                        'Journey Option',
                        'Under-writing Decision',
                        'Created On',
                        'Agent Code',
                        'Channel',
                        'Sub Channel',
                        'Proposer Name',
                        'Product Name',
                        'Total Premium',
                        "Payment Method",
                        'Renewal Method Selected',
                        'Vertical',
                        'Sub Vertical',
                        'Lg Code',
                        'Bharti Axa Emp Code',
                        'Centre Head',
                        'Bank Customer Id',
                        'Branch Code',
                        'Branch Name',
                        'Bank Source Code',
                        'Bank Referal Code',
                        'Rating',
                        'Issuance Type',
                    ]}
                    data={this.props.dashboardData.selectedProposals}
                    keys={['proposalId', 'leadId', 'proposalNumber', 'policyNumber','payStatus','transactionDate','refundCompleted','partnerName', 'premium','sumAssured', 'premiumPaymentMode', 'quoteNumber', 'emailId', 'mobileNumber', 'policyCreated', 'policyStatus', 'journeyStatus', 'selectedJourney',
                        'underWritingDecision', 'createdOn', 'agentCode', 'channel', 'subChannel', 'proposerName', 'productName', 'totalPremium', "paymentMethod", 'renewalPaymentMethod',
                        'vertical', 'subVertical', 'lgCode', 'bhartiAxaEmpCode', 'centreHead', 'bankCustomerId', 'branchCode', 'branchName',
                        'bankSourceCode', 'bankReferralCode','ratingScore','issuanceType']}
                    fileName="Proposals"
                    addSerialNo={true}
                    showExcelDownload={true}
                    PerPageApiData={false}
                    paginationItems={this.props.dashboardData.selectedProposals}
                    alwaysShown={false}
                /></div> : ''}
                {
                    showPaymentPopUp && <MobilePopUp
                        heading={`Payment Method for ${selectedPn}`}
                        onClose={() => {
                            this.setState({
                                selectedPn: "",
                                showPaymentPopUp: false
                            });
                            this.props.resetPaymentMethod()
                        }}
                    >
                        <div className="dashboard-payment-method-list">
                            {
                                this.props.paymentMethodList.length > 0 && this.props.paymentMethodList !== "No Data" ?
                                    this.props.paymentMethodList.map(item => <li key={item}>
                                        {item}
                                    </li>) : this.props.paymentMethodList
                            }
                        </div>

                    </MobilePopUp>
                }
            </div>)
    }
}

const mapStateToProps = (state) => {
    return {
        dashboardData: state.dashboardData,
        authentication: state.authentication,
        paymentMethodList: state.dashboardData.paymentMethodList,

    };
};

export default connect(mapStateToProps, {
    proposalCount2,
    getSelectedProposalData2,
    changeType,
    getPaymentMethodData,
    resetPaymentMethod,
})(ProposalDashboard);
